// extracted by mini-css-extract-plugin
module.exports = {"full":"index__full___3NHg9","large":"index__large___3i2Cp","medium":"index__medium___1MXBI","small":"index__small___s6JuR"};